import 'phoenix_html';
import { Socket } from 'phoenix';
import { LiveSocket } from 'phoenix_live_view';
import { Hooks as FluxonHooks, DOM as FluxonDOM } from 'fluxon';

let LocaleHook = {
  mounted() {
    this.handleEvent("set_locale", ({locale}) => {
      document.cookie = `_locale=${locale};path=/;max-age=${365 * 24 * 60 * 60};SameSite=Lax`;
      document.documentElement.setAttribute("lang", locale);
    });
  }
};

let csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");
let liveSocket = new LiveSocket("/live", Socket, {
  longPollFallbackMs: 2500,
  params: {_csrf_token: csrfToken},
  hooks: { ...FluxonHooks, LocaleHook },
  dom: {
    onBeforeElUpdated(from, to) {
      FluxonDOM.onBeforeElUpdated(from, to);
    },
  },
});

liveSocket.connect();
